import { render } from "./shareInvoiceModal.vue?vue&type=template&id=613e428e"
import script from "./shareInvoiceModal.vue?vue&type=script&lang=js"
export * from "./shareInvoiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__